import { endpoints } from "../../../../ApiEndPoints/apiEndPoints"
import { familyGroupManagementType } from "../../../../Types/familyGroupManagementType"
import { IPayloadFamilyGroupAdmin } from "../../../../Types/filterTypeForFamilyGroupAdminType"
import { RequestDecoratorModel } from "../../../../Types/requestDecoratorModel"

export const decoratePayloadAndEndPoint = (editableData: any, selectedMenu: string): RequestDecoratorModel => {

  //In case if any service required additional header, it need to reassign in respective block
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }

  let data: RequestDecoratorModel = {
    endPoint: "",
    headers: null,
    payload: null,
    method: ""
  };

  switch (selectedMenu) {
    case 'Summary':
      const payloadSummary: IPayloadFamilyGroupAdmin = {
        NewFamilyGroup: editableData?.FamilyGroupNew,
        FamilyGroup: editableData.FamilyGroup,
        Company: editableData?.Company,
        SuperCategory: editableData?.SuperCategory,
        SubCategory: editableData?.SubCategory,
        Category: editableData?.Category,
        BusinessUnit: editableData?.BusinessUnit,
        Segment: editableData?.Segment,
        ProductType: editableData?.ProductType,
      }

      data = {
        payload: payloadSummary,
        headers: headers,
        endPoint: endpoints.updateFamilyGroupAdmin(),
        method: "PATCH"
      }
      break;
    case 'Management':
      const payLoadManagement: familyGroupManagementType = {
        Id: editableData?.Id,
        FamilyGroup: editableData?.FamilyGroup?.trim(),
        ProductType: editableData?.ProductType,
        SubCategory: editableData?.SubCategory,
        LPFamilyGroupMix: editableData?.LPFamilyGroupMix,
        MLPFamilyGroupMix: editableData?.MLPFamilyGroupMix,
        SerialControl: editableData?.SerialControl,
        SerialInputMask: editableData?.SerialInputMask,
        StrapTotes: editableData?.StrapTotes
      }

      data = {
        payload: payLoadManagement,
        headers: headers,
        endPoint: endpoints.updateFamilyGroup(editableData?.Id),
        method: "PATCH"
      }
      break;
    default:
      break;
  }
  return data;
}